// Corporate Slate — tech companies, SaaS, startups
// Cool grays + electric blue, modern rounded
module.exports = {
  effect: 'network',
  colors: {
    main:            { light: '#f1f5f9', dark: '#0f172a' },
    card:            { light: '#e2e8f0', dark: '#1e293b' },
    surface:         { light: '#cbd5e1', dark: '#334155' },
    action:          { light: '#2563eb', dark: '#3b82f6' },
    actionHover:     { light: '#1d4ed8', dark: '#60a5fa' },
    textPrimary:     { light: '#0f172a', dark: '#f1f5f9' },
    textSecondary:   { light: '#1e293b', dark: '#cbd5e1' },
    textMuted:       { light: '#475569', dark: '#94a3b8' },
    textMutedSubtle: { light: '#64748b', dark: '#64748b' },
    border:          { light: '#94a3b8', dark: '#334155' },
    borderSubtle:    { light: '#cbd5e1', dark: '#1e293b' },
    link:            { light: '#1d4ed8', dark: '#60a5fa' },
    linkBg:          { light: '#eff6ff', dark: 'rgba(59,130,246,0.12)' },
    linkBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
    linkHover:       { light: '#dbeafe', dark: 'rgba(59,130,246,0.22)' },
    inputBg:         { light: '#ffffff', dark: '#1e293b' },
    inputBorder:     { light: '#94a3b8', dark: '#334155' },
    inputText:       { light: '#0f172a', dark: '#f1f5f9' },
    focusRing:       { light: '#2563eb', dark: '#93c5fd' },
    overlay:         { light: 'rgba(0,0,0,0.5)', dark: 'rgba(0,0,0,0.75)' },
    confirm:         { light: '#64748b', dark: '#475569' },
    confirmHover:    { light: '#475569', dark: '#64748b' },
    confirmText:     { light: '#ffffff', dark: '#f1f5f9' },
    confirmBg:       { light: '#f8fafc', dark: '#1e293b' },
    confirmBorder:   { light: '#e2e8f0', dark: '#334155' },
    success:         { light: '#059669', dark: '#10b981' },
    successHover:    { light: '#047857', dark: '#059669' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#34d399' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#dc2626', dark: '#ef4444' },
    errorHover:      { light: '#b91c1c', dark: '#dc2626' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#0284c7', dark: '#0284c7' },
    infoHover:       { light: '#0369a1', dark: '#0ea5e9' },
    infoBg:          { light: '#f0f9ff', dark: 'rgba(3,105,161,0.25)' },
    infoText:        { light: '#0ea5e9', dark: '#38bdf8' },
    infoBorder:      { light: '#bae6fd', dark: '#075985' },
  },
  borderRadius: {
    card:      '24px',
    container: '14px',
    page:      '20px',
    button:    '8px',
    input:     '8px',
    badge:     '5px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '3px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
